import AuthService from '@di/auth-service';
function getEnvFromHostname() {
    var parts = window.location.hostname.split('.');
    if (parts.length === 0)
        return 'development';
    var subdomain = parts[0];
    var dashParts = subdomain.split('-');
    if (dashParts.length < 2)
        return subdomain === 'localhost' ? 'local' : 'production';
    return dashParts[dashParts.length - 1] === 'stg' ? 'staging' : 'development';
}
var auth = new AuthService({
    appName: 'notification',
    environment: process.env.APP_EXECUTION_ENV === 'local'
        ? 'local'
        : getEnvFromHostname(),
    usePkce: process.env.APP_EXECUTION_ENV === 'local'
});
export default auth;
